export const cloneOriginElement = (el: HTMLElement): HTMLElement => {
  const bounds = el.getBoundingClientRect()
  const cloned = el.cloneNode(true) as HTMLElement
  cloned.style.userSelect = 'none'
  cloned.style.zIndex = '100000'
  cloned.style.position = 'absolute'
  cloned.style.height = `${bounds.height}px`
  cloned.style.width = `${bounds.width}px`
  return cloned
}
